module.exports = __webpack_public_path__ + "img/twitter_example_2.e9053d70.jpg";